module.exports = __webpack_public_path__ + "img/airballon.ccbb2fb4.png";